// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-search-Search-module__searchBoxParent {
    margin: 0.1rem 0.5rem 0.5rem 0.5rem;
}

.src-sidebar-search-Search-module__searchBox {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    grid-gap: 0.5rem;
    margin: 0.5rem 0.1rem 0.7rem 0;
}

.src-sidebar-search-Search-module__searchBoxScrollable {
    overflow-y: auto;
    overflow-x: hidden;
}

.src-sidebar-search-Search-module__searchBoxInput {
    grid-column: 2 / span 2;
}

.src-sidebar-search-Search-module__removeSearchBox {
    grid-column: 4;
    width: 1rem;
    color: #adadad;
    justify-self: center;
}

.src-sidebar-search-Search-module__markerContainer {
    grid-column: 1 / span 1;
    align-self: center;
    justify-self: center;
    width: 1rem;
}

.src-sidebar-search-Search-module__markerContainer > svg {
    height: 100%;
    width: 100%;
}

.src-sidebar-search-Search-module__searchOptions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 0;
}

.src-sidebar-search-Search-module__geocodingResults {
    grid-column: 1 / span 3;
}

.src-sidebar-search-Search-module__addSearchBox {
    font-size: 14px;
    color: gray;
}

.src-sidebar-search-Search-module__settingsButton,
.src-sidebar-search-Search-module__settingsButton:hover {
    font-size: 14px;
    font-weight: bold;
    color: rgba(39, 100, 200, 0.85);
}

.src-sidebar-search-Search-module__settingsButton:hover {
    color: rgb(35, 92, 185);
}

.src-sidebar-search-Search-module__lastSearchLine {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-right: 2px;
}

.src-sidebar-search-Search-module__addSearchBox:hover path,
.src-sidebar-search-Search-module__infoButton:hover path {
    fill: black;
}

.src-sidebar-search-Search-module__infoButton:active path,
.src-sidebar-search-Search-module__addSearchBox:active path,
.src-sidebar-search-Search-module__markerTarget:active path {
    fill: lightgray;
}

.src-sidebar-search-Search-module__addSearchBox svg {
    width: 18px;
    height: 18px;
}

.src-sidebar-search-Search-module__addSearchBox svg {
    color: #adadad;
    padding: 0 1.25em 0 0;
}

.src-sidebar-search-Search-module__addSearchBox {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
}

.src-sidebar-search-Search-module__infoButton svg {
    fill: #adadad;
}

.src-sidebar-search-Search-module__markerContainer:hover svg {
    fill: black !important;
}

.src-sidebar-search-Search-module__markerContainer,
.src-sidebar-search-Search-module__markerSelected,
.src-sidebar-search-Search-module__markerTarget {
    grid-column: 1 / span 1;
    align-self: center;
    justify-self: center;
    width: 1rem;
}

.src-sidebar-search-Search-module__markerContainer {
    outline: none;
}

.src-sidebar-search-Search-module__markerTarget:hover svg {
    fill: black;
}

.src-sidebar-search-Search-module__markerContainer > svg,
.src-sidebar-search-Search-module__markerTarget > svg {
    height: 100%;
    width: 100%;
}

.src-sidebar-search-Search-module__markerSelected {
    margin-left: -4px;
}

.src-sidebar-search-Search-module__markerTarget > svg {
    transform: scaleX(1.7) scaleY(1.5);
    margin-left: 3px;
    fill: gray;
}

.src-sidebar-search-Search-module__dropPreview > svg {
    fill: black;
}

.src-sidebar-search-Search-module__hide {
    visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/search/Search.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".searchBoxParent {\n    margin: 0.1rem 0.5rem 0.5rem 0.5rem;\n}\n\n.searchBox {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    grid-gap: 0.5rem;\n    margin: 0.5rem 0.1rem 0.7rem 0;\n}\n\n.searchBoxScrollable {\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.searchBoxInput {\n    grid-column: 2 / span 2;\n}\n\n.removeSearchBox {\n    grid-column: 4;\n    width: 1rem;\n    color: #adadad;\n    justify-self: center;\n}\n\n.markerContainer {\n    grid-column: 1 / span 1;\n    align-self: center;\n    justify-self: center;\n    width: 1rem;\n}\n\n.markerContainer > svg {\n    height: 100%;\n    width: 100%;\n}\n\n.searchOptions {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 1rem 0;\n}\n\n.geocodingResults {\n    grid-column: 1 / span 3;\n}\n\n.addSearchBox {\n    font-size: 14px;\n    color: gray;\n}\n\n.settingsButton,\n.settingsButton:hover {\n    font-size: 14px;\n    font-weight: bold;\n    color: rgba(39, 100, 200, 0.85);\n}\n\n.settingsButton:hover {\n    color: rgb(35, 92, 185);\n}\n\n.lastSearchLine {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-right: 2px;\n}\n\n.addSearchBox:hover path,\n.infoButton:hover path {\n    fill: black;\n}\n\n.infoButton:active path,\n.addSearchBox:active path,\n.markerTarget:active path {\n    fill: lightgray;\n}\n\n.addSearchBox svg {\n    width: 18px;\n    height: 18px;\n}\n\n.addSearchBox svg {\n    color: #adadad;\n    padding: 0 1.25em 0 0;\n}\n\n.addSearchBox {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: row;\n}\n\n.infoButton svg {\n    fill: #adadad;\n}\n\n.markerContainer:hover svg {\n    fill: black !important;\n}\n\n.markerContainer,\n.markerSelected,\n.markerTarget {\n    grid-column: 1 / span 1;\n    align-self: center;\n    justify-self: center;\n    width: 1rem;\n}\n\n.markerContainer {\n    outline: none;\n}\n\n.markerTarget:hover svg {\n    fill: black;\n}\n\n.markerContainer > svg,\n.markerTarget > svg {\n    height: 100%;\n    width: 100%;\n}\n\n.markerSelected {\n    margin-left: -4px;\n}\n\n.markerTarget > svg {\n    transform: scaleX(1.7) scaleY(1.5);\n    margin-left: 3px;\n    fill: gray;\n}\n\n.dropPreview > svg {\n    fill: black;\n}\n\n.hide {\n    visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBoxParent": `src-sidebar-search-Search-module__searchBoxParent`,
	"searchBox": `src-sidebar-search-Search-module__searchBox`,
	"searchBoxScrollable": `src-sidebar-search-Search-module__searchBoxScrollable`,
	"searchBoxInput": `src-sidebar-search-Search-module__searchBoxInput`,
	"removeSearchBox": `src-sidebar-search-Search-module__removeSearchBox`,
	"markerContainer": `src-sidebar-search-Search-module__markerContainer`,
	"searchOptions": `src-sidebar-search-Search-module__searchOptions`,
	"geocodingResults": `src-sidebar-search-Search-module__geocodingResults`,
	"addSearchBox": `src-sidebar-search-Search-module__addSearchBox`,
	"settingsButton": `src-sidebar-search-Search-module__settingsButton`,
	"lastSearchLine": `src-sidebar-search-Search-module__lastSearchLine`,
	"infoButton": `src-sidebar-search-Search-module__infoButton`,
	"markerTarget": `src-sidebar-search-Search-module__markerTarget`,
	"markerSelected": `src-sidebar-search-Search-module__markerSelected`,
	"dropPreview": `src-sidebar-search-Search-module__dropPreview`,
	"hide": `src-sidebar-search-Search-module__hide`
};
export default ___CSS_LOADER_EXPORT___;
